import { PointChangeFilter, usePointChangeQuery } from '@occc/graphql';

export const useGetPointChangeById = (idEquals?: string) => {
  const filter: PointChangeFilter = {
    idEquals,
  };

  const skip = !idEquals;

  const response = usePointChangeQuery({
    notifyOnNetworkStatusChange: true,
    variables: { filter },
    skip,
  });

  const node = response?.data?.pointChanges?.edges?.[0]?.node;
  return {
    ...response,
    data: node,
  };
};
